import React from "react";
import { connect } from "react-redux";
import { TrackJS } from "trackjs";

import {
  setCreditCardRequestStatus,
  submitCreditCardPayment,
} from "actions/digital_gift_cards";
import ErrorPage from "components/digital_gift_cards/error_page";
import PurchasePage from "components/digital_gift_cards/purchase_page";
import Loader from "components/loader";
import { settingsIncludesRequiredValues } from "helpers/digital_gift_cards";

import type { DigitalGiftCardsStore } from "types/digital_gift_cards";
import { RequestStatus } from "types/requests";

function DigitalGiftCardsContainer(props: DigitalGiftCardsStore) {
  const { settingsRequest } = props;

  switch (settingsRequest.type) {
    case RequestStatus.FAILURE: {
      return <ErrorPage />;
    }

    case RequestStatus.SUCCESS: {
      const { digitalGiftCardEnabled } = settingsRequest.result;
      const hasRequiredSettings = settingsIncludesRequiredValues(
        settingsRequest.result
      );

      if (!hasRequiredSettings) {
        TrackJS.track(
          "digital gift card configuration is missing required settings"
        );
      }

      if (digitalGiftCardEnabled && hasRequiredSettings) {
        return <PurchasePage settings={settingsRequest.result} {...props} />;
      }
      return <ErrorPage />;
    }

    default: {
      return (
        <div className="app">
          <Loader />
        </div>
      );
    }
  }
}

function mapStateToProps(state: DigitalGiftCardsStore) {
  return {
    settingsRequest: state.settingsRequest,
    afterProcessedPaymentRequest: state.afterProcessedPaymentRequest,
    creditCardRequestStatus: state.creditCardRequestStatus,
  };
}

const mapDispatchToProps = {
  onSubmitCreditCardPayment: submitCreditCardPayment,
  onSetCreditCardRequestStatus: setCreditCardRequestStatus,
};

const ConnectedDigitalGiftCardsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(DigitalGiftCardsContainer);

export default ConnectedDigitalGiftCardsContainer;
